import React, { useState } from 'react';

import { usePostPastoralVisit } from '../../../api/actions/usePostPastoralVisit';
import RequestError from '../RequestError';
import OrderSuccess from '../OrderSuccess';
import PastoralVisitForm from '../PastoralVisitForm';

const PastoralVisitContent = () => {
  const { mutate, error, loading } = usePostPastoralVisit();
  const [success, setSuccess] = useState(false);

  const handleSubmit = async values => {
    const { error: mutateError } = await mutate(values);
    if (!mutateError) {
      setSuccess(true);
    }
  };

  return (
    <>
      {!loading && error && <RequestError />}
      {success ? (
        <OrderSuccess onNewSubmissionClick={() => setSuccess(false)} />
      ) : (
        <PastoralVisitForm onSubmit={handleSubmit} />
      )}
      {!loading && error && <RequestError />}
    </>
  );
};

PastoralVisitContent.propTypes = {};

export default PastoralVisitContent;
